<template>
  <RouterLink :to="content.link" :class="{'button': button, '--full': full, '--secondary': secondary, '--top': top}">
    {{ content.label }}
  </RouterLink>
</template>

<script>
import {HasContentMixin} from '@/mixins'

export default {
  name: 'InternalLink',
  mixins: [HasContentMixin],
  props: {
    button: {
      type: Boolean,
      default: false
    },
    full: {
      type: Boolean,
      default: false
    },
    secondary: {
      type: Boolean,
      default: false
    },
    top: {
      type: Boolean,
      default: false
    }
  }
}
</script>